import React from 'react';
import { withRouter } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import PropTypes from 'prop-types';
// import validate from 'validate.js';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Button, 
  TextField, 
  Typography
} from '@material-ui/core';
import api from '../../services/api';
import { login } from "../../auth";


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.black,
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: {
    color: theme.palette.white
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  socialButtons: {
    marginTop: theme.spacing(3)
  },
  socialIcon: {
    marginRight: theme.spacing(1)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  }
}));

const SignIn = props => {
  const { history } = props;
  const classes = useStyles();
  const { handleSubmit, control } = useForm(); 
  // const [modal, setModal] = React.useState(0);

  const onSubmit = async data => {
    let response;
    console.log(data);
    try {
      response = await api.post('auth', {
        cpf: data.cpf,
        password: data.password
      });
      
    console.log(response.data);
      if (response.status == 200) {
        localStorage.setItem("@Nome", response.data.username);
        localStorage.setItem("@Funcao", response.data.funcao); 
        login(data.cpf);
        history.push("/contracheque");
      }
    }
    catch {
      response = "";
      // setModal(1);
    }
  }

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
      >
        <Grid
          className={classes.quoteContainer}
          item
          lg={5}
        >
          <div className={classes.quote}>
            <div className={classes.quoteInner}>
              <Typography
                className={classes.quoteText}
                variant="h1"
              >
                O Talento vence Jogos, Mas só o trabalho em quipe ganha campeonatos.
              </Typography>
              <div className={classes.person}>
                <Typography
                  className={classes.name}
                  variant="body1"
                >
                  .
                </Typography>
                <Typography
                  className={classes.bio}
                  variant="body2"
                >
                  .
                </Typography>
              </div>
            </div>
          </div>
        </Grid>
        <Grid
          className={classes.content}
          item
          lg={7}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentBody}>

              <form
                className={classes.form}
                onSubmit={handleSubmit(onSubmit)}>

                <Typography
                  className={classes.title}
                  variant="h2"
                >
                  Entrar
                </Typography>
  
                <Controller as={TextField}
                  className={classes.textField}
                  fullWidth
                  label="CPF"
                  name="cpf" 
                  type="text"
                  variant="outlined"
                  control={control} 
                  defaultValue=""
                />
                <Controller as={TextField}
                  className={classes.textField}
                  fullWidth
                  label="Senha"
                  name="password" 
                  type="password"
                  variant="outlined"
                  control={control} 
                  defaultValue=""
                />
                <Button
                  className={classes.signInButton}
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  ENTRAR
                </Button> 

              </form>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

SignIn.propTypes = {
  history: PropTypes.object
};

export default withRouter(SignIn);
